"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const Hidden_1 = require("@material-ui/core/Hidden");
const styles_1 = require("@material-ui/core/styles");
const react_i18next_1 = require("react-i18next");
const ShieldIcon_1 = require("../arcade/ShieldIcon");
const ShoppingCartSmall_1 = require("./ShoppingCartSmall");
const ShoppingCartWide_1 = require("./ShoppingCartWide");
const styles = (theme) => (0, styles_1.createStyles)({
    proceed: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center'
        },
        marginTop: theme.spacing(3)
    },
    proceedBtn: {
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    }
});
const ShoppingCardTable = ({ items, total, onAddItem, onRemoveAll, onRemoveItem, proceedCheckout, t, classes }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ smUp: true }, { children: (0, jsx_runtime_1.jsx)(ShoppingCartSmall_1.default, { onAddItem: onAddItem, onRemoveItem: onRemoveItem, onRemoveAll: onRemoveAll, items: items, total: total, proceedCheckout: proceedCheckout }) })), (0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ xsDown: true }, { children: (0, jsx_runtime_1.jsx)(ShoppingCartWide_1.default, { onAddItem: onAddItem, onRemoveItem: onRemoveItem, onRemoveAll: onRemoveAll, items: items, total: total, proceedCheckout: proceedCheckout }) })), proceedCheckout && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.proceed }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ variant: 'contained', size: 'large', color: 'primary', className: classes.proceedBtn, onClick: proceedCheckout }, { children: [t('store.shoppingCart.continue'), (0, jsx_runtime_1.jsx)(ShieldIcon_1.default, { size: 16 })] })) })))] }));
exports.default = (0, styles_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(ShoppingCardTable));
//# sourceMappingURL=ShoppingCartTable.js.map